/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Nafis Bey",
  title: "Hi, I'm Nafis.",
  subTitle: emoji(
    "Senior Full Stack Software Engineer 👨🏾‍💻 with 10+ years building enterprise web and mobile applications. I work across the stack — from RESTful APIs and cloud infrastructure to component-driven front-ends — with a focus on testing, reliability, and clean architecture."
  ),
  resumeLink: null,
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/nbey",
  linkedin: "https://www.linkedin.com/in/nafisb/",
  gmail: "nafis@nafis.me",
  gitlab: null,
  facebook: null,
  medium: null,
  stackoverflow: null,
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: emoji(
    "Inquisitive Internet Scientist 👨🏾‍🔬 who likes experimenting with the latest tech stacks"
  ),
  skills: [
    emoji(
      "⚡ Architect / Develop / Test / Deploy web and mobile applications and APIs"
    ),
    emoji(
      "⚡ Customize and implement continuous integration / continuous delivery (CI/CD) strategies"
    ),
    emoji(
      "⚡ Integration of third party APIs & Services such as AWS / GCP / Stripe / Quickbooks / Google Analytics, etc."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d =gallery */

  softwareSkills: [
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Vue.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Svelte",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "SvelteKit",
      fontAwesomeClassname: "fas fa-code"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Parkway West High School",
      logo: require("./assets/images/pwhs.jpeg"),
      subHeader: "Diploma",
      duration: "September 2006 - July 2010",
      desc: null, //"Participated in the research of XXX and published 3 papers.",
      descBullets: [
        // "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend/API",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend/UI", //Insert stack or technology you have experience in
      progressPercentage: "75%" //Insert relative proficiency in percentage
    },
    {
      Stack: "DevOps",
      progressPercentage: "75%"
    }
  ]
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Sr. Application Developer",
      company: "American College of Physicians",
      companylogo: require("./assets/images/ACP_logo_200.png"),
      dates: ["March 2025 – Present"],
      desc: "The American College of Physicians (ACP) is the largest medical specialty organization in the world with 162,000 members in more than 172 countries across the globe. ACP is a diverse community of internal medicine specialists and subspecialists united by a commitment to excellence.",
      descBullets: [
        "Drove quality assurance initiative by designing and rolling out company-wide testing standards for custom modules",
        "Built and maintained tailored Drupal modules to meet complex functional needs, integrating external systems and implementing site-specific features"
      ]
    },
    {
      role: "Sr. Software Engineer",
      company: "Jarvus Innovations",
      companylogo: require("./assets/images/jarvus_j_sm.png"),
      dates: ["January 2012 – June 2018", "October 2022 – October 2023"],
      desc: "Jarvus is a web software engineering firm passionate about building impactful systems and companies. Responsible for architecting, developing and deploying web and mobile applications, as well as maintain and improve on Jarvus’ open-source PHP framework, Emergence.",
      descBullets: [
        "Lead Software Engineer across multiple projects, as well as worked within teams",
        "Worked directly with clients to design, implement, and suggest new features"
      ]
    },
    {
      role: "Full-Stack Software Engineer",
      company: "Independent / Contract",
      companylogo: require("./assets/images/freelance-logo.svg").default,
      dates: ["June 2018 – Present"],
      desc: "Freelance and contract engineering across nonprofits, education, and veterinary sectors. Led end-to-end development on multiple client projects as the sole engineer, handling architecture, implementation, and deployment.",
      descBullets: [
        "Slate — Implemented data synchronization and SSO between Canvas, Infinite Campus, Looker, and Google Suite for an open-source education integration platform",
        "Indevets — Automated feature-branch releases on Kubernetes via GitHub Actions and architected a QuickBooks API integration for invoicing and analytics workflows",
        "Children's Literacy Initiative — Built an internal application with real-time account provisioning and granular permission management"
      ]
    },
    {
      role: "Front-End Engineer",
      company: "Elsevier",
      companylogo: require("./assets/images/elsevier.png"),
      dates: ["October 2018 – April 2019"],
      desc: "Elsevier is a global information analytics business that helps institutions progress science, advance healthcare and improve performance. Aligned to the CK Student Assessments application, which is Elsevier’s digital teaching and learning platform for healthcare professionals, particularly nurses and medical assistants.",
      descBullets: [
        "Sole UI engineer within a six-person cross-disciplinary team (UX Designers, Java Engineer, QE), agile team environment",
        "Developed and brought product from MVP to launch in UK market"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Key Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/slate-logo-blue.png"),
      imageBackgroundColor: false,
      projectName: "Slate",
      projectDesc:
        "Slate is an open source education integration platform that allows schools to create and purchase innovative software. This enables them to own their own data, and have quick and easy access to building their own ed-tech tools.",
      footerLink: [
        {
          name: "Visit Slate",
          url: "http://slate.is/"
        }
      ]
    },
    {
      image: require("./assets/images/ptw18-logo-comcast.png"),
      imageBackgroundColor: true,
      projectName: "Philly Tech Week",
      projectDesc:
        "Philly Tech Week is a week-long celebration of technology and innovation happening throughout the Greater Philadelphia region.",
      footerLink: [
        {
          name: "Philly Tech Week",
          url: "http://2018.phillytechweek.com/"
        },
        {
          name: "Baltimore Innovation Week",
          url: "http://2018.baltimoreinnovationweek.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Press",
  subtitle: "Featured coverage and recognition.",

  achievementsCards: [
    {
      title: "Technical.ly — Featured",
      subtitle:
        '"Why dev firm Jarvus trained, then hired, Philly public school grads" — Coverage of the AmeriCorps Digital Service Fellows apprenticeship pipeline that launched my career in software engineering.',
      image: require("./assets/images/technically-logo.svg").default,
      imageAlt: "Technical.ly logo",
      footerLink: [
        {
          name: "Read the article",
          url: "https://technical.ly/software-development/jarvus-innovations-hired-digital-service-fellows/"
        }
      ]
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

// Talks Sections

const talkSection = {
  title: "Talks",
  subtitle: "",
  talks: [],
  display: false
};

// Podcast Section

const podcastSection = {
  title: "Podcast",
  subtitle: "",
  podcast: [],
  display: false
};

const contactInfo = {
  title: emoji("Contact Me 📩"),
  displayOpportunityOpeness: true,
  subtitle:
    "Open to senior engineering opportunities — remote or Philadelphia-area.",
  // number: "+92-0000000000",
  email_address: "nafis@nafis.me"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
